import React from 'react'
import { redirect } from 'next/navigation'

import { IRedirectToProps } from './types'

export const RedirectTo: React.FC<IRedirectToProps> = ({ to = '/' }) => {
  return redirect(to)
}
